import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { IKnmForm } from 'KnmPackage/MainModule/interfaces/IKnmForm';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';

const idRegex = /\[\d+]/gi;

export const getIsDirtyAgreement = (
  dirtyFields:
    | {
        [key: string]: boolean;
      }
    | undefined,
  index?: number,
  formRef?: IKnmFormRef | IDecisionFormRef,
) => {
  const firstKey: string = 'agreements';

  if (!dirtyFields) {
    return { wasEditFiled: false, wasEditWithoutViolationsFixed: false };
  }

  // eslint-disable-next-line no-param-reassign
  delete dirtyFields[firstKey];

  if (Object.keys(dirtyFields).length === 0) {
    return { wasEditFiled: false, wasEditWithoutViolationsFixed: false };
  }

  const wasEditWithoutViolationsFixed = !Object.keys(dirtyFields).find(i => {
    return !!blackList.find(j => {
      const regexpS = i.replaceAll(idRegex, '[{id}]');

      return regexpS.indexOf(j) > -1;
    });
  });

  const wasEditFiled = !!Object.keys(dirtyFields).find(key => {
    const fieldNameTemplate = key
      .split('.')
      .map(item => (item.indexOf(firstKey) === -1 ? item?.replace(idRegex, '[{id}]') : item))
      .join('.');
    // @ts-ignore
    const { initial, value } = formRef?.current.getFieldState(key as keyof IKnmForm) || {};

    let isDeleteLastElementFromArray = false;

    if (
      (Array.isArray(initial) || Array.isArray(value)) &&
      (initial === undefined || (Array.isArray(initial) && initial.length < 1)) &&
      Array.isArray(value) &&
      value.length < 1
    ) {
      isDeleteLastElementFromArray = true;
    }

    return !!fields.find(f => {
      const fieldNameInList = index !== undefined ? f.replace('[{id}]', `[${index}]`) : f;

      return fieldNameInList === fieldNameTemplate && !isDeleteLastElementFromArray;
    });
  });

  return { wasEditFiled, wasEditWithoutViolationsFixed };
};

const blackList: string[] = [
  'violatedMandatory[{id}].violations[{id}].isFixed',
  'violatedMandatory[{id}].violations[{id}].isViolationResolved',
  'violatedMandatory[{id}].violations[{id}].isViolationResolvedNote',
  'violatedMandatory[{id}].violations[{id}].fixes[{id}].grade',
  'violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationGrade',
  'terminate',
];

const fields = [
  'agreements[{id}].prescription',
  'agreements[{id}].violations',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixPlanMethodsRequired',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixPlanDates[{id}].value',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixPlanExplanationsRequired',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].title',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixFactMethod',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].method',
  'agreements[{id}].petitionOrganizationType',
  'agreements[{id}].petitionAttachment',
  'agreements[{id}].petitionOrganization.inn',
  'agreements[{id}].petitionOrganization.ogrn',
  'agreements[{id}].petitionOrganization.snils',
  'agreements[{id}].petitionOrganization.subjectType',
  'agreements[{id}].petitionOrganization.organizationName',
  'agreements[{id}].petitionOrganization.factualAddress',
  'agreements[{id}].petitionOrganization.locationAddress',
  'agreements[{id}].petitionOrganization.country',
  'agreements[{id}].petitionOrganization.rafpNza',
  'agreements[{id}].petitionOrganization.kpp',
  'agreements[{id}].petitionOrganization.document',
  'agreements[{id}].petitionOrganization.locationAddress',
  'agreements[{id}].approvalOfAgreement',
  'agreements[{id}].approvalOfAgreementAttachment',
  'agreements[{id}].eliminateViolationsNumber',
  'agreements[{id}].conclusionDate',
  'agreements[{id}].eliminateViolationsAttachment',
  'agreements[{id}].termOfExecutionAgreement',
  'agreements[{id}].applicationForConsiderationAttachment',
  'agreements[{id}].violationCorrectionProgramAttachments',
  'agreements[{id}].otherAttachments',
  'agreements[{id}].prosecutorOrganization',
  'agreements[{id}].fioSigner',
  'agreements[{id}].titleSigner',
  'agreements[{id}].approveInfo.note',
  'agreements[{id}].approveInfo.approved',
  'agreements[{id}].approveInfo.numberDecision',
  'agreements[{id}].approveInfo.dateDecision',
  'agreements[{id}].approveInfo.whoMadeDecision',
  'agreements[{id}].approveInfo.titleSigner',
  'agreements[{id}].approveInfo.reasonForRefusal',
  'agreements[{id}].approveInfo.attachment',
  'agreements[{id}].terminate.terminationReasons',
  'agreements[{id}].terminate.decisionTerminationAttachment',
  'agreements[{id}].terminate.titleSigner',
  'agreements[{id}].terminate.titleSigner.label',
  'agreements[{id}].terminate.fioSigner',
  'agreements[{id}].execution.decision',
  'agreements[{id}].execution.executionDate',
  'agreements[{id}].execution.titleSigner',
  'agreements[{id}].execution.fioSigner',
  'agreements[{id}].changes[{id}].types',
  'agreements[{id}].changes[{id}].types[{id}].type',
  'agreements[{id}].changes[{id}].reasons',
  'agreements[{id}].changes[{id}].reasons[{id}]',
  'agreements[{id}].changes[{id}].attachment',
  'agreements[{id}].changes[{id}].termOfExecutionAgreement',
  'agreements[{id}].changes[{id}].updatedAgreementAttachment',
  'agreements[{id}].changes[{id}].petitionAttachment',
  'agreements[{id}].changes[{id}].titleSigner',
  'agreements[{id}].changes[{id}].fioSigner',
];
